@if (steps!==undefined) {
  <div>
    <nav ngbNav class="nav-tabs" #t="ngbNav" [destroyOnHide]="false" [(activeId)]="activeId">
      @for (step of steps; track step; let i = $index) {
        <ng-container [ngbNavItem]="i">
          <a ngbNavLink (click)="getTab(step.key)">
            {{step.name}}
          </a>
          <ng-template ngbNavContent>
          </ng-template>
        </ng-container>
      }
    </nav>
    <div class="me-auto p-2">
      @if (tab === 'EVALUATION') {
        <button type="button" class="btn btn-sm btn-outline-secondary mb-2"
          (click)="filtersCollapsed = !filtersCollapsed"
          [attr.aria-expanded]="!filtersCollapsed" aria-controls="evaluationFilters">
          <lucide-icon name="funnel" size="16"></lucide-icon>
          {{'CONTROL-MODULE.FILTERS' | translate}}
          @if (activeFilterCount() > 0) {
            <span class="badge bg-primary ms-1">{{activeFilterCount()}}</span>
          }
          <lucide-icon [name]="filtersCollapsed ? 'chevron-down' : 'chevron-up'" size="16"></lucide-icon>
        </button>
      }
      <div id="evaluationFilters" [ngbCollapse]="tab === 'EVALUATION' && filtersCollapsed">
        <form [formGroup]="filterForm">
          <input class="form-control" style="max-width: 300px;" formControlName="search" placeholder="{{'CONTROL-MODULE.SEARCH' | translate}}" />
          <table style="margin-top: 10px;" class="filter-table">
            <tr>
              <td><label for="risks">{{'CONTROL-MODULE.RISKS' | translate}}</label></td>
              <td><label for="year">{{'CONTROL-MODULE.YEAR' | translate}}</label></td>
              <td><label for="semester">{{'CONTROL-MODULE.SEMESTER' | translate}}</label></td>
              <td><label for="ifu">{{'CONTROL-MODULE.IFU' | translate}}</label></td>
              <td><label for="executionTask">{{'CONTROL-MODULE.EXECUTION_TASK' | translate}}</label></td>
              <td><label for="sources">{{'CONTROL-MODULE.SOURCE' | translate}}</label></td>
              <td><label for="performers">{{'CONTROL-MODULE.EXECUTIVE' | translate}}</label></td>
            </tr>
            <tr>
              <td>
                <div class="form-group" style="max-width:220px;">
                  @if (risks$) {
                    <ntr-multiple-select #riskMulti [items]="risks$"
                      [key]="'key'" [display]="'name'" (onUpdate)="printValue($event, 'risk')">
                    </ntr-multiple-select>
                  }
                </div>
              </td>
              <td>
                <div class="form-group" style="max-width:220px; position: relative; top:0;">
                  <select id="year" class="form-control" formControlName="year">
                    @for (value of ['-'].concat(years); track value) {
                      <option value={{value}}>
                        {{value}}
                      </option>
                    }
                  </select>
                </div>
              </td>
              <td>
                @if (this.filterForm) {
                  <div class="form-group" style="max-width:220px; position: relative; top:0;">
                    <select id="semester" class="form-control" formControlName="semester">
                      @for (value of ['-',1,2]; track value) {
                        <option value="{{value}}">{{value}}</option>
                      }
                    </select>
                  </div>
                }
              </td>
              <td>
                <div class="form-group" style="max-width:220px;">
                  @if (risks$) {
                    <ntr-multiple-select #ifuMulti [items]="ifus$"
                      [key]="'key'" [display]="'name'" (onUpdate)="printValue($event, 'ifu')">
                    </ntr-multiple-select>
                  }
                </div>
              </td>
              <td>
                <div class="form-group" style="max-width:220px; position: relative; top:0;">
                  <ng-select id="executionTask"
                    style="width:220px;"
                    formControlName="executionTask"
                    [items]="executionTasks"
                    bindLabel="name"
                    bindValue="key"
                    [clearable]="true"
                    [appendTo]="'body'">
                  </ng-select>
                </div>
              </td>
              <td>
                <div class="form-group" style="max-width:220px;">
                  @if (risks$) {
                    <ntr-multiple-select #ifuMulti [items]="sources$"
                      [key]="'key'" [display]="'name'" (onUpdate)="printValue($event, 'source')">
                    </ntr-multiple-select>
                  }
                </div>
              </td>
              <td>
                <div class="form-group" style="max-width:220px;">
                  @if (risks$) {
                    <ntr-multiple-select #ifuMulti1 [items]="performers$"
                      [key]="'key'" [display]="'name'" (onUpdate)="printValue($event, 'performer')">
                    </ntr-multiple-select>
                  }
                </div>
              </td>
            </tr>
          </table>
        </form>
      </div>
    </div>
    <div class="tab-content" id="myTabContent">
      @for (step of steps; track step; let i = $index) {
        <div class="tab-pane fade" [ngClass]="{'show active': i === 0}"
          id="{{step.key}}" role="tabpanel" attr.aria-labelledby="{{step.key}}-tab" style="padding-top:20px;">
          @if (isSingle()) {
            <accordion>
              @for (action of step.actions; track action) {
                <accordion-group heading="{{action.name}}">
                  @for (actionElement of action.actionElements; track actionElement) {
                    <app-action-element [item]="actionElement">
                    </app-action-element>
                  }
                </accordion-group>
              }
            </accordion>
          }
          @if (processes) {
            <div>
              <div class="" style="height: 60px;">
                <div class="btn-toolbar p-2" role="toolbar" style="float: left;">
                  @if (tab !== 'EVALUATION') {
                    <div class="btn-group-md mx-2">
                      <button type="button" class="btn btn-primary" (click)="downloadList('api/control/report') ">
                        <lucide-icon name="cloud-download" size="16"></lucide-icon>
                        {{'CONTROL-MODULE.DOWNLOAD_LIST' |
                        translate}}
                      </button>
                    </div>
                  }
                  @if (tab !== 'EVALUATION') {
                    <div class="btn-group-md mx-2">
                      <button type="button" class="btn btn-primary"
                        (click)="downloadList('api/control/report/distribution') ">
                        <lucide-icon name="cloud-download" size="16"></lucide-icon>
                        {{'CONTROL-MODULE.DOWNLOAD_REPART' |
                        translate}}
                      </button>
                    </div>
                  }
                  @if (tab && tab === 'TOAPPROVE') {
                    <div class="btn-group-md me-2">
                      <button type="button" class="btn btn-warning"
                        (click)="openModal(template)">
                        <lucide-icon name="circle-check" size="16"></lucide-icon>
                        {{'CONTROL-MODULE.APPROVE_ALL' |
                        translate}}
                      </button>
                    </div>
                  }
                </div>
              </div>
              @if (tab !== 'EVALUATION') {
                <div class="row">
                  @for (process of processes; track process) {
                    <div class="col-xs-12 col-sm-8 col-md-6 col-lg-4 col-xl-3 mb-4">
                      <app-process-card [process]="process" [companyId]="process.company.id">
                      </app-process-card>
                    </div>
                  }
                </div>
              }
              @if (tab === 'EVALUATION') {
                <div class="table-responsive">
                  <h5 class="evaluation-section-title">{{'CONTROL-MODULE.EVAL_TAB_SUMMARY' | translate}}</h5>
                  <table class="table table-striped table-hover evaluation-table">
                    <thead>
                      <tr>
                        <th scope="col">{{'CONTROL-MODULE.COL_COMPANY' | translate}}</th>
                        <th scope="col">{{'CONTROL-MODULE.COL_TIN' | translate}}</th>
                        <th scope="col">{{'CONTROL-MODULE.COL_CONTROL_ID' | translate}}</th>
                        <th scope="col">{{'CONTROL-MODULE.COL_AMR' | translate}}</th>
                        <th scope="col">{{'CONTROL-MODULE.COL_PRINCIPAL' | translate}}</th>
                        <th scope="col">{{'CONTROL-MODULE.COL_PENALTY' | translate}}</th>
                        <th scope="col">{{'CONTROL-MODULE.COL_TOTAL' | translate}}</th>
                        <th scope="col">{{'CONTROL-MODULE.COL_ACTIONS' | translate}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (process of processes; track process) {
                        <tr>
                          <td>{{process.company.name}}</td>
                          <td>{{process.company.tax_id}}</td>
                          <td>{{process.uniqueId}}</td>
                          <td>{{displayOrDash(process.amrNumber)}}</td>
                          <td>{{displayOrDash(process.issuedPrincipal)}}</td>
                          <td>{{displayOrDash(process.issuedPenalty)}}</td>
                          <td>{{displayOrDash(process.issuedTotal)}}</td>
                          <td class="actions-cell">
                            <a [routerLink]="['/process', process._id, process.task.key, process.company.id]"
                              class="btn btn-sm btn-outline-primary me-1">
                              {{'CONTROL-MODULE.OPEN' | translate}}
                            </a>
                            <a [routerLink]="['/timeline', process._id]"
                              class="btn btn-sm btn-outline-primary">
                              {{'CONTROL-MODULE.TIMELINE' | translate}}
                            </a>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
              @if (tab === 'EVALUATION') {
                <hr class="evaluation-divider">
              }
              @if (tab === 'EVALUATION') {
                <div class="table-responsive">
                  <h5 class="evaluation-section-title">{{'CONTROL-MODULE.EVAL_TAB_DETAILED' | translate}}</h5>
                  <table class="table table-striped table-hover evaluation-table evaluation-detailed-table">
                    <thead>
                      <tr>
                        <th scope="col" rowspan="2">{{'CONTROL-MODULE.COL_DENOMINATION' | translate}}</th>
                        <th scope="col" rowspan="2">{{'CONTROL-MODULE.COL_NIU' | translate}}</th>
                        <th scope="col" rowspan="2">{{'CONTROL-MODULE.COL_DATE_NOTICE_SENT' | translate}}</th>
                        <th scope="col" rowspan="2">{{'CONTROL-MODULE.COL_WORKS_POSTPONE_DELAY' | translate}}</th>
                        <th scope="col" rowspan="2">{{'CONTROL-MODULE.COL_WORKS_START' | translate}}</th>
                        <th scope="col" rowspan="2">{{'CONTROL-MODULE.COL_WORKS_END' | translate}}</th>
                        <th scope="col" rowspan="2">{{'CONTROL-MODULE.COL_BASES_NOTIFIED' | translate}}</th>
                        <th scope="col" rowspan="2">{{'CONTROL-MODULE.COL_REDRESS_HEADS' | translate}}</th>
                        <th scope="col" rowspan="2">{{'CONTROL-MODULE.COL_OBS_RECEIVED' | translate}}</th>
                        <th scope="col" rowspan="2">{{'CONTROL-MODULE.COL_LRO_DATE' | translate}}</th>
                        <th scope="col" rowspan="2">{{'CONTROL-MODULE.COL_AMR_NUMBER' | translate}}</th>
                        <th scope="col" colspan="3" class="text-center">{{'CONTROL-MODULE.COL_AMOUNTS_ISSUED' | translate}}</th>
                        <th scope="col" colspan="3" class="text-center">{{'CONTROL-MODULE.COL_AMOUNTS_RECOVERED' | translate}}</th>
                        <th scope="col" rowspan="2">{{'CONTROL-MODULE.COL_OBSERVATIONS' | translate}}</th>
                      </tr>
                      <tr>
                        <th scope="col">{{'CONTROL-MODULE.COL_PRINCIPAL' | translate}}</th>
                        <th scope="col">{{'CONTROL-MODULE.COL_PENALTY' | translate}}</th>
                        <th scope="col">{{'CONTROL-MODULE.COL_TOTAL' | translate}}</th>
                        <th scope="col">{{'CONTROL-MODULE.COL_PRINCIPAL' | translate}}</th>
                        <th scope="col">{{'CONTROL-MODULE.COL_PENALTY' | translate}}</th>
                        <th scope="col">{{'CONTROL-MODULE.COL_TOTAL' | translate}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (process of processes; track process) {
                        <tr>
                          <td>{{process.company.name}}</td>
                          <td>{{process.company.tax_id}}</td>
                          <td>{{displayOrDash(process.noticeSentDate)}}</td>
                          <td>{{displayOrDash(process.worksPostponementDelay)}}</td>
                          <td>{{displayOrDash(process.worksStartDate)}}</td>
                          <td>{{displayOrDash(process.worksEndDate)}}</td>
                          <td>{{displayOrDash(process.basesNotifiedDate)}}</td>
                          <td>{{displayOrDash(process.redressHeadsCount)}}</td>
                          <td>{{displayOrDash(process.observationsReceivedDate)}}</td>
                          <td>{{displayOrDash(process.lroDate)}}</td>
                          <td>{{displayOrDash(process.amrNumber)}}</td>
                          <td>{{displayOrDash(process.issuedPrincipal)}}</td>
                          <td>{{displayOrDash(process.issuedPenalty)}}</td>
                          <td>{{displayOrDash(process.issuedTotal)}}</td>
                          <td>{{displayOrDash(process.recoveredPrincipal)}}</td>
                          <td>{{displayOrDash(process.recoveredPenalty)}}</td>
                          <td>{{displayOrDash(process.recoveredTotal)}}</td>
                          <td>{{displayOrDash(process.comment?.text)}}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
              <div class="col-xs-12 col-12 mt-3">
                <ngb-pagination class="d-flex justify-content-center"
                  [maxSize]="10"
                  [pageSize]="10"
                  [boundaryLinks]="true"
                  [collectionSize]="totalCount"
                [(page)]="numPages" (pageChange)="changePage($event)"></ngb-pagination>
              </div>
            </div>
          }
        </div>
      }
    </div>
    <ng-template #template>
      <div class="modal-body text-center">
        <p>{{'CONTROL-MODULE.SURE_TO_APPROVE_ALL' | translate}}</p>
        <button type="button" class="btn btn-outline-secondary" (click)="confirmApproveAll()" >{{'CONTROL-MODULE.YES' | translate}}</button>
        <button type="button" class="btn btn-primary" (click)="modalRef?.hide()" >{{'CONTROL-MODULE.CANCEL' | translate}}</button>
      </div>
    </ng-template>
  </div>
}

<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
